'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialFacebookCircular = function TiSocialFacebookCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.6 9.4c-2.9-2.9-6.5-4.4-10.6-4.4-4.1 0-7.7 1.5-10.6 4.4-2.9 2.9-4.4 6.5-4.4 10.6 0 4.1 1.5 7.7 4.4 10.6 2.9 2.9 6.4 4.4 10.6 4.4 4.1 0 7.7-1.5 10.6-4.4 2.9-2.9 4.4-6.5 4.4-10.6 0-4.1-1.5-7.7-4.4-10.6z m-2.4 18.8c-1.9 1.9-4 3-6.5 3.3v-8.2h3.3v-3.3h-3.3v-2.3c0-0.6 0.4-1 1-1h2.3v-3.4h-2.3c-1.3 0-2.3 0.5-3.1 1.4-0.8 0.9-1.3 2-1.3 3.4v1.9h-3.3v3.3h3.3v8.3c-2.5-0.4-4.7-1.5-6.6-3.4-2.3-2.3-3.4-5-3.4-8.2 0-3.3 1.1-6 3.4-8.3 2.3-2.3 5-3.4 8.3-3.4 3.2 0 5.9 1.1 8.2 3.4 2.3 2.3 3.5 5 3.5 8.3 0 3.2-1.2 5.9-3.5 8.2z' })
        )
    );
};

exports.default = TiSocialFacebookCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-facebook-circular.js
// module id = 2170
// module chunks = 0